import { FormHandles } from '@unform/core'
import { t } from 'i18next'

import Form from '~/components/unform/Form'
import EditFormActions from '~/modules/retailMedia/components/EditFormActions'

import FieldsetAdditionalAsset from './FieldsetAdditionalAsset'

const EditMode: React.FC<EditModeProps<FormHandles>> = ({
  formRef,
  initialData,
  mainBackground,
  secondaryBackground,
  loadingSave,
  onSubmit,
  onCancel
}) => (
  <Form onSubmit={onSubmit} ref={formRef} initialData={initialData}>
    <FieldsetAdditionalAsset
      formRef={formRef}
      initialData={mainBackground}
      assetName="main_background"
      label={t('rm:campaign.additionalAssets.mainBackground')}
    />

    <FieldsetAdditionalAsset
      formRef={formRef}
      initialData={secondaryBackground}
      assetName="secondary_background"
      label={t('rm:campaign.additionalAssets.secondaryBackground')}
    />

    <EditFormActions loadingSave={loadingSave} onCancel={onCancel} />
  </Form>
)

export default EditMode
